// @owners { team: patients-team }
export const STALE_FEES_ERROR_CODE = 'stale_fees_error';
